import { API } from "apis";
import Chip from "components/common/Chip";
import PageTitle from "components/common/PageTitle";
import PageLabel from "components/common/paging/PageLabel";
import Pagination from "components/common/paging/Pagination2";
import ThreadAdminSearchArea from "components/thread/admin-list/ThreadAdminSearchArea";
import { ContextModel, CorpModel, ThreadAdminListModel } from "models";
import { ThreadAdminSearchOptions } from "models/ThreadAdminSearchOptions";
import qs from "query-string";
import React from "react";
import { Helmet } from "react-helmet-async";
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { Utils } from "utils";

const ThreadAdminListPage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();

  const location = useLocation();
  const navigate = useNavigate();

  const [corpList, setCorpList] = React.useState<CorpModel[]>();
  // 直前に検索を行ったクエリ
  const searchedQuery = React.useRef<string>();
  // 検索オプション
  const options = React.useRef<ThreadAdminSearchOptions>({});
  const [data, setData] = React.useState<ThreadAdminListModel>();

  const reload = async () => {
    console.log("reload");

    for (let key in options.current) {
      if ((options.current as any)[key] === "") {
        delete (options.current as any)[key];
      }
    }

    const params = qs.stringify(options.current);
    if (location.search !== "?" + params) {
      navigate({ pathname: location.pathname, search: params });
    }
  };

  const onSearch = async () => {
    delete options.current.page_no;

    reload();
  };

  const onChangePage = async (value: number) => {
    if (value <= 1) {
      delete options.current.page_no;
    } else {
      options.current.page_no = value;
    }

    reload();
  };

  React.useEffect(() => {
    if (searchedQuery.current === location.search) {
      console.log("useEffect => load cancel.");
      return;
    }
    console.log("useEffect => load start. : " + location.search);
    searchedQuery.current = location.search;
    const f = async () => {
      ctx.loading.setState(true);
      if (!ctx.auth.data) {
        await ctx.auth.initialize();
      }

      // optionsを一度クリアしてから、クエリの状態に
      for (let k in options.current) {
        delete (options.current as any)[k];
      }
      const query = qs.parse(location.search);
      if (query.page_no !== undefined) {
        options.current.page_no = Number(query.page_no);
      }
      if (query.receive_corp_id !== undefined) {
        options.current.receive_corp_id = String(query.receive_corp_id);
      }
      if (query.send_corp_id !== undefined) {
        options.current.send_corp_id = String(query.send_corp_id);
      }
      if (query.keyword !== undefined) {
        options.current.keyword = String(query.keyword);
      }
      if (query.is_show_all !== undefined) {
        options.current.is_show_all = query.is_show_all === "true";
      }

      if (!corpList) {
        try {
          const response = await API.Corp.list();
          console.log(response);
          setCorpList(response.data);
        } catch (err) {
          Utils.errorAction(ctx, err);
        }
      }

      const response = await API.Thread.adminSearch(options.current);
      console.log(response);
      setData(response.data);
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });

      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  if (!data) {
    return <div></div>;
  }

  return (
    <div>
      <Helmet>
        <title>掲示板管理</title>
      </Helmet>
      <PageTitle title="掲示板管理" className="p-2" />

      <ThreadAdminSearchArea
        corpList={corpList}
        options={options.current}
        data={data}
        onSearch={onSearch}
      />

      {data.threads.length === 0 ? (
        <div className="flex justify-center py-12">
          <div>検索結果がありません。</div>
        </div>
      ) : (
        <div className="m-4">
          <PageLabel data={data} />
          <table className="w-full table-fixed mt-4">
            <thead className="border-b">
              <tr>
                <th className="text-left">発注会社名</th>
                <th className="w-28">状態</th>
                <th className="text-left">受注会社名</th>
                <th className="text-left">件名</th>
                <th className="w-36">最終更新日</th>
              </tr>
            </thead>
            <tbody>
              {data?.threads.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className={`border-b ${
                      item.thread_status === 1 && "bg-gray-300"
                    }`}
                  >
                    <td>{item.send_corp_name}</td>
                    <td>
                      <div className="py-2 flex flex-col items-center">
                        {item.thread_status === 1 ? (
                          <Chip text="完了" width="5rem" color="#8e8e8e" />
                        ) : (
                          <Chip text="進行中" width="5rem" color="#149fec" />
                        )}
                        <div>{item.thread_type_name}</div>
                      </div>
                    </td>
                    <td>{item.receive_corp_name}</td>
                    <td>
                      <Link
                        to={`/talk-detail/${item.thread_id}/`}
                        className="hover:underline text-jhk-blue"
                      >
                        {item.thread_title}
                      </Link>
                    </td>
                    <td className="text-center">
                      {Utils.Date.format(item.last_update_datetime)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="flex justify-center m-4">
            <Pagination
              page={options.current?.page_no ?? 1}
              data={data}
              onChange={onChangePage}
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default ThreadAdminListPage;
